import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProgramService } from 'src/app/core/service/program.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { forkJoin } from 'rxjs';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  selector: 'app-program-detail',
  templateUrl: './program-detail.component.html',
  styleUrls: ['./program-detail.component.scss']
})
export class ProgramDetailComponent implements OnDestroy
{
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  /**
   * Program ID
   */
  public id: number;

  /**
   * Data model object for this component.
   */
  public program: any = {};

  /**
   * Indicates if the page is loading.
   */
  public loading = true;

  /**
   * Program metrics
   */
  public programMetrics: any = [];

  /**
   * Subscriptions
   */
  private routeParamSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messageHandlerService: MessageHandlerService,
    private programService: ProgramService)
  {
    // subscribe to route parameter changes.
    this.routeParamSubscription = this.route.params.subscribe({
      next: (params: Params) =>
      {
        this.id = +params.id;
        this.getProgramMetrics();
      }
    });
  }

  public ngOnDestroy(): void
  {
    // unsubscribe to route parameter changes.
    if (this.routeParamSubscription !== undefined) { this.routeParamSubscription.unsubscribe(); }
  }

  /**
   * Navigate to back program edit screen.
   */
  public backToProgramEdit(): void
  {
    this.router.navigateByUrl(`/program-edit/${this.id}`);
  }

  public showTooltip(e: ElementRef): void
  {
    this.tooltipDir.toggle(e, true);
  }
  
  public hideTooltip(): void
  {
    this.tooltipDir.hide();
  }

  /**
   * Get the program metrics to render the summary. This fetch the program and programs metrics data.
   */
  private getProgramMetrics(): void
  {
    this.loading = true;
    this.programMetrics = [];

    const queries: any = [];
    queries.push(this.programService.getProgram(this.id));
    queries.push(this.programService.getProgramMetrics(this.id));

    forkJoin(queries).subscribe({
      next: (responseList: any) =>
      {
        // Set program data
        this.program = responseList[0];
        this.programMetrics = responseList[1].metrics;
      },
      error: (error) =>
      {
        // failed to retrieve channel, reset the view model and render with the error set for display
        this.messageHandlerService.displayError(error);
        this.loading = false;
      },
      complete: () =>
      {
        this.loading = false;
      }
    });
  }
}
